import { render, staticRenderFns } from "./earn.vue?vue&type=template&id=445fad61&scoped=true&"
import script from "./earn.vue?vue&type=script&lang=js&"
export * from "./earn.vue?vue&type=script&lang=js&"
import style0 from "./earn.vue?vue&type=style&index=0&id=445fad61&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "445fad61",
  null
  
)

export default component.exports